<aside class="side-nav" aria-label="Primary navigation">
  <button
    class="toggle"
    type="button"
    [attr.aria-label]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
    [title]="collapsed() ? 'Expand' : 'Collapse'"
    (click)="toggle()"
  >
    <i class="pi" [class.pi-angle-right]="collapsed()" [class.pi-angle-left]="!collapsed()"></i>
  </button>

  <!-- Labeled so this <nav> landmark is distinguishable from other nav
       landmarks on the page (top bar, breadcrumbs, in-page pagers).
       The outer <aside> carries its own "Primary navigation" label for
       the complementary landmark; this one names the nav landmark itself. -->
  <nav class="items" aria-label="Primary">
    @for (group of items; track group.label; let first = $first) {
      <!-- Section divider — replaces the previous text heading. A hairline
           <hr> visually separates groups without adding vocabulary. Skipped
           for the first group so the top of the menu doesn't lead with a
           divider. Still labeled semantically via an sr-only span so
           screen readers announce the group boundary; the ul below
           aria-labelledby's this element for section context. -->
      @if (!first) {
        <hr class="section-divider" role="presentation" />
      }
      <span class="sr-only" [id]="group.id">{{ group.label }}</span>

      <!-- Flat children list — no indentation. aria-labelledby ties
           each ul to its group heading so screen readers announce
           the section context on entering. -->
      <ul
        class="section-items"
        role="list"
        [attr.aria-labelledby]="group.id"
      >
        @for (child of group.items; track child.route) {
          <!-- Compute the shared label once per item so aria-label and
               title don't each re-invoke the helper (which reads the
               collapsed() signal and does a Set lookup for unseen).
               Null when expanded — both [attr.*] bindings then drop
               off, so no tooltip can overlap the visible label. -->
          @let collapsedLabel = collapsedAriaLabel(child);
          <li>
            <!-- PrimeNG's pTooltip instead of the native `title`
                 attribute — native tooltips have a browser-controlled
                 (~500ms) delay and are suppressed while the anchor
                 is being clicked / focus-moved, which made hovers
                 across the narrow icon column often show nothing.
                 tooltipDisabled falls back to null-out when expanded
                 so the visible label isn't shadowed. -->
            <a
              class="link"
              [routerLink]="child.route"
              routerLinkActive="active"
              [attr.aria-label]="collapsedLabel"
              [pTooltip]="collapsedLabel ?? ''"
              tooltipPosition="right"
              [tooltipDisabled]="!collapsed()"
              [showDelay]="120"
            >
              <i [class]="'icon ' + child.icon" aria-hidden="true"></i>
              @if (!collapsed()) {
                <span class="label">{{ child.label }}</span>
              }
              @if (isUnseen(child)) {
                <span class="dot" aria-hidden="true"></span>
              }
            </a>
          </li>
        }
      </ul>
    }
  </nav>
</aside>
